<template>
  <v-menu v-model="showMenu" bottom left transition="slide-y-transition" :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn x-small>
        <v-icon small v-on="on">mdi-cog</v-icon>
      </v-btn>
    </template>
    <template>
      <v-card class="mx-auto" max-width="500">
        <v-list dense>
          <v-list-group no-action eager>
            <template v-slot:activator>
              <v-list-item-title>{{ $t('motlet.taskType') }}</v-list-item-title>
            </template>
            <v-list-item-group v-model="selected" multiple>
              <v-list-item dense ref="checkAll" value="-1" @click="onClickCheckAll">
                <template v-slot:default>
                  <v-list-item-action>
                    <v-checkbox dense :input-value="activeCheckAll" readonly></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title v-text="checkAllText"></v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
              <template v-for="(taskType, index) in partialTaskType">
                <v-list-item :key="index" :value="taskType.value" @click="onClickCheck">
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox dense :input-value="active"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title v-text="taskType.label"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list-group>
        </v-list>
      </v-card>
    </template>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex';
import motletable from '../../../mixins/motletable';
import { api } from '../../../api/common/instances';
import bus from '../../../utils/bus';

export default {
  mixins: [motletable],
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showMenu: false,
      interval: 0,
      checkAllText: this.$t('motlet.taskType.checkAll'),
      activeCheckAll: false,
    };
  },
  computed: {
    ...mapState('common/user', ['username']),
    ...mapState('common/properties', ['partialTaskType']),
    selected: {
      get() {
        return this.taskType ? this.taskType.split(',') : [];
      },
      set(value) {
        let taskType = '';
        if (!this.activeCheckAll) {
          const index = value.indexOf('-1');
          if (index > -1) value.splice(index, 1);
          taskType = value.sort((a, b) => a - b).join(',');
        }
        this.setTaskType(taskType);
      },
    },
  },
  watch: {
    showMenu(value) {
      if (value) {
        if (!this.taskType) this.$nextTick(() => this.setCheckAll(true));
      } else {
        api
          .put(`/prefer/users/${this.username}/motlet-properties`, {
            motletId: this.motletId,
            motletProperties: this.taskType,
          })
          .then(() => {
            bus.$emit(`update:taskType-${this.motletId}`, this.taskType);
          });
      }
    },
    selected(value) {
      this.setCheckAll(value.length ? false : true);
    },
  },
  methods: {
    onClickCheck() {
      this.activeCheckAll = false;
    },
    setCheckAll(active) {
      if (!this.$refs.checkAll) return;
      this.activeCheckAll = active;
      const method = active ? 'add' : 'remove';
      const classList = this.$refs.checkAll.$el.classList;
      classList[method]('v-item--active');
      classList[method]('v-list-item--active');
    },
    onClickCheckAll() {
      const isActive = () => {
        const classList = this.$refs.checkAll.$el.classList;
        return !Array.from(classList).some(item => item == 'v-item--active');
      };
      this.activeCheckAll = true;
      if (!isActive()) {
        this.interval = setInterval(() => {
          if (!isActive()) clearInterval(this.interval);
          this.setCheckAll(true);
        }, 100);
      }
    },
  },
};
</script>
